module.exports = __webpack_public_path__ + "media/images/1200/about-621c7fe53915984e57c1c0fe50af7a51.jpg";